import script from "./comVersion.vue?vue&type=script&setup=true&lang=js"
export * from "./comVersion.vue?vue&type=script&setup=true&lang=js"

import "./comVersion.vue?vue&type=style&index=0&id=41b7db88&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41b7db88"]])

export default __exports__